import { flatten } from 'util/flatten';

import { DepartmentModel } from 'api/dto/Department.dto';

const buildName = (name: string, prefixes: string[] = []) => flatten([prefixes, name]).join(' -> ');

const handleItem = (
  item: DepartmentModel,
  prefixes: string[] = [],
  result: { name: string; id: number }[] = [],
) => {
  const name = buildName(item.name, prefixes);
  result.push({
    name: name,
    id: item.id,
  });

  item.children.forEach((child) => {
    handleItem(child, prefixes.concat([item.name]), result);
  });

  return result;
};

export const createDepartmentTreeList = (tree: DepartmentModel[]) =>
  flatten(tree.map((item) => handleItem(item)));

export const createDepartmentTreeListUnique = (
  tree: DepartmentModel[],
): { name: string; id: number }[] =>
  createDepartmentTreeList(tree).reduce((accumulator, current) => {
    if (!accumulator.find((item: { name: string; id: number }) => item.id === current.id)) {
      accumulator.push(current);
    }
    return accumulator;
  }, []);

export const createExcludingDepartmentTreeList = (
  departments: DepartmentModel[],
  department: DepartmentModel,
): { name: string; id: number }[] => {
  const hasChildren = Array.isArray(department?.children) && department?.children.length > 0;

  const childrenIds = hasChildren ? getAllChildrenIds(department) : [];

  return createDepartmentTreeList(departments)
    .filter((item) => !childrenIds.includes(item.id))
    .filter((item) => item.id !== department?.id && item.id !== department?.parentId);
};

export const getAllChildrenIds = (department: DepartmentModel): number[] | any => {
  if (department.children) {
    const result = department.children.map((item) => getAllChildrenIds(item));

    return flatten([department.id, flatten(result)]);
  } else {
    return department.id;
  }
};
